<div class="bg-white shadow-lg position-fixed rounded-3" 
     style="width: 300px; top: 50px; right: 5px; z-index: 999999;">
  
  <div class="d-flex justify-content-between align-items-center border-bottom p-2">
    <span class="fw-bold">Notifications</span>
    <button type="button" class="btn-close" (click)="closePopup()" aria-label="Close"></button>
  </div>

  <div class="overflow-auto" style="max-height: 85vh;">
    
    <div class="text-center fst-italic text-muted p-3" 
         *ngIf="allLoaded && notifications.length == 0">
      You have no notifications
    </div>

    <div class="d-flex justify-content-between align-items-center p-2 border-bottom" 
         *ngIf="allLoaded && notifications.length > 0">
      <small class="adl-link" 
             *ngIf="showAll" (click)="showUnread()">
        Show Unread
      </small>
      <small class="adl-link" 
             *ngIf="!showAll" (click)="showAllNotifications()">
        Show All
      </small>
      <small class="adl-link" 
             (click)="markAllRead()">
        Mark All Read
      </small>
    </div>

    <ng-container *ngFor="let n of notifications">
      <div *ngIf="showAll || (!showAll && !n.isRead)" 
           class="d-flex align-items-center justify-content-between p-2 m-2 border rounded"
           [ngClass]="{'border-dark border-2 fw-bold shadow-sm': !n.isRead, 'border-secondary': n.isRead}"
           style="font-size: 13px;">
        
        <div class="d-flex flex-column flex-grow-1" 
             [ngClass]="{'cursor-pointer': n.caseId !== null}"
             (click)="clickNotification(n)">
          <span>{{n.notificationText}}</span>
          <small class="fst-italic text-muted" style="font-size: 10px;">
            {{n.dateCreated | date:'dd/MM/yyyy HH:mm:ss'}}
          </small>
        </div>

        <div class="d-flex gap-2 ms-2">
          <span class="text-success" style="cursor: pointer;" 
                *ngIf="n.isRead" (click)="markAsUnread(n)">
            <fa-icon [icon]="faUndoAlt"></fa-icon>
          </span>
          <span class="text-danger" style="cursor: pointer;" 
                (click)="dismiss(n)">
            <fa-icon [icon]="faTrashAlt"></fa-icon>
          </span>
        </div>

      </div>
    </ng-container>

  </div>

</div>